/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const encounterTabSettings = sqliteTable('encounter_tab_settings', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  user_id: text('user_id'),
  preset: text('preset'),
  tabs_json: text('tabs_json'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
